import {
  useFloating,
  autoUpdate,
  offset,
  flip,
  shift,
  useHover,
  useFocus,
  useDismiss,
  useRole,
  useInteractions,
  FloatingPortal
} from '@floating-ui/react'
import PropTypes from 'prop-types'
import { useState } from 'react'
import './ToolTip.css'

const TOOLTIP_OFFSET = 10
const TOOLTIP_PADDING = 5
const DEFAULT_DURATION_OPEN = 200
const DEFAULT_DURATION_CLOSE = 150

const ToolTip = ({
  children,
  contenido,
  delay = 0,
  duracion = [DEFAULT_DURATION_OPEN, DEFAULT_DURATION_CLOSE],
  interactivo = false,
  deshabilitado = false,
  visible,
  esconder = false,
  flecha = true
}) => {
  const [isOpen, setIsOpen] = useState(false)

  const { refs, floatingStyles, context } = useFloating({
    open: visible !== undefined ? visible : isOpen,
    onOpenChange: setIsOpen,
    placement: 'top',
    whileElementsMounted: autoUpdate,
    middleware: [offset(TOOLTIP_OFFSET), flip(), shift({ padding: TOOLTIP_PADDING })]
  })

  const hover = useHover(context, {
    enabled: !deshabilitado,
    delay: typeof delay === 'number' ? delay : { open: delay[0], close: delay[1] }
  })
  const focus = useFocus(context, { enabled: !deshabilitado })
  const dismiss = useDismiss(context)
  const role = useRole(context, { role: 'tooltip' })

  const { getReferenceProps, getFloatingProps } = useInteractions([
    hover,
    focus,
    dismiss,
    role
  ])

  // Evitar warning de variables no usadas (mantener compatibilidad con API anterior)
  void duracion
  void interactivo

  if (esconder) {
    return <>{children}</>
  }

  const showTooltip = visible !== undefined ? visible : isOpen

  return (
    <>
      <span ref={refs.setReference} {...getReferenceProps()}>
        {children}
      </span>
      {showTooltip && contenido && (
        <FloatingPortal>
          <div
            ref={refs.setFloating}
            style={floatingStyles}
            {...getFloatingProps()}
            className="tooltip-floating"
          >
            {contenido}
            {flecha && <div className="tooltip-arrow" />}
          </div>
        </FloatingPortal>
      )}
    </>
  )
}

ToolTip.propTypes = {
  esconder: PropTypes.bool,
  children: PropTypes.node.isRequired,
  contenido: PropTypes.string,
  delay: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)]),
  duracion: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)]),
  interactivo: PropTypes.bool,
  deshabilitado: PropTypes.bool,
  visible: PropTypes.bool,
  flecha: PropTypes.bool
}

export default ToolTip
